import { TableHeaderColumnType } from '../../../../components/Table/TableHeader.component';

export const TABLE_HEADER_COLUMNS: TableHeaderColumnType[] = [
  {
    title: 'Date',
    dataProperty: 'date',
    sortable: true,
    sort: 'desc',
  },
  {
    title: 'Full Name',
    dataProperty: 'full_name',
    sortable: true,
  },
  {
    title: 'Jobs',
    dataProperty: 'jobs',
    sortable: false,
  },
  {
    title: 'Experience',
    dataProperty: 'experience',
    sortable: true,
  },
  {
    title: 'English level',
    dataProperty: 'english',
    sortable: true,
  },
  {
    title: 'Status',
    dataProperty: 'status',
    sortable: false,
  },
  {
    title: 'Favourites',
    dataProperty: 'isFavourite',
    sortable: false,
  },
];

export const CREATE_ICON_SIZE = 18;
